import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import InputField from "../../../components/form/InputField";
import SelectField from "../../../components/form/SelectField";
import ResourseButtons from "../../../components/form/buttons/ResourseButtons";
import { useDispatch, useSelector } from "react-redux";
import {
  addAccount,
  editAccount,
  getAccountCategories,
  getAccountTypes,
  unsetAccountCategories,
} from "../../../features/accountsSlice";
import Loading from "../../../components/loading/Loading";
import { closeModal } from "../../../features/modalSLice";
import { useNotification } from "../../../components/notification/NotificationContainer";
import { zodResolver } from "@hookform/resolvers/zod";
import { addAccountSchema, editAccountSchema } from "../../../schemas";
import { getCurrencies } from "../../../features/currenciesSlice";
import { useCallback } from "react";
import loadStatus from "../../../util/loadStatus";

const AddChartAccount = ({ edit, id }) => {
  const dispatch = useDispatch();
  const accountTypes = useSelector((state) => state.accounts.accountTypes);
  const currencies = useSelector((state) => state.currencies.data);
  const account = useSelector((state) => state.accounts.selectedAccount);
  const addNotification = useNotification();
  const addAccountLoad = useSelector((state) => state.accounts.load.addAccount);
  const editAccountLoad = useSelector(
    (state) => state.accounts.load.editAccount
  );

  const accountCategories = useSelector(
    (state) => state.accounts.accountCategories
  );
  const accountTypesLoad = useSelector(
    (state) => state.accounts.load.getAccountTypes
  );
  const currenciesLoad = useSelector(
    (state) => state.currencies.load.getCurrencies
  );
  const accountCategoriesLoad = useSelector(
    (state) => state.accounts.load.getAccountCategories
  );
  const accountLoad = useSelector((state) => state.accounts.load.getAccount);
  let [categories, setCategories] = useState(accountCategories);
  const {
    handleSubmit,
    register,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    defaultValues: {
      id: "",
      account_type_id: "",
      category_id: "",
      currency_id: "",
    },
    resolver: zodResolver(edit ? editAccountSchema : addAccountSchema),
  });

  const accountType = watch("account_type_id");

  const onSubmit = async (data, e) => {
    e.preventDefault();
    let res;
    try {
      if (!edit) {
        res = await dispatch(addAccount(data));
        if (addAccount.fulfilled.match(res)) {
          dispatch(closeModal());
          addNotification("Account added successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      } else {
        res = await dispatch(editAccount({ id: id, data }));
        if (editAccount.fulfilled.match(res)) {
          dispatch(closeModal());
          dispatch(getAccountTypes());
          addNotification("Account updated successfully!", "success");
        } else {
          addNotification(res.payload.message, "error");
        }
      }
    } catch (error) {
      addNotification(error.message, "warning");
    }
  };

  const getAllData = useCallback(async () => {
    await Promise.all([
      dispatch(getAccountTypes()),
      dispatch(getAccountCategories()),
      dispatch(getCurrencies()),
    ]);
  });

  useEffect(() => {
    // dispatch(getAccountTypes());
    // dispatch(getAccountCategories());
    // dispatch(getCurrencies());

    getAllData();

    return () => {
      dispatch(unsetAccountCategories());
    };
  }, []);

  useEffect(() => {
    if (!accountType) {
      setCategories([]);
    } else {
      setCategories(
        accountCategories.filter((val) => val.account_type_id === accountType)
      );
    }
  }, [accountType]);

  useEffect(() => {
    if (account.id || categories.length > 0) {
      setCategories(
        accountCategories.filter(
          (val) => val.account_type_id === account.account_type_id
        )
      );
      reset({
        id: account.id,
        name: account.name,
        account_type_id: account.account_type_id,
        category_id: account.category_id,
        currency_id: account.currency_id,
      });
    }
  }, [account, accountCategories, currencies]);

  if (
    accountTypesLoad === loadStatus.loading ||
    accountCategoriesLoad === loadStatus.loading ||
    accountLoad === loadStatus.loading ||
    currenciesLoad === loadStatus.loading
  ) {
    return <Loading />;
  }
  return (
    <div className="overflow-auto ">
      <h5 className="text-center  mb-7 text-primary">
        {edit ? "EDIT ACCOUNT" : "ADD ACCOUNT"}
      </h5>
      <form autoComplete="off" onSubmit={handleSubmit(onSubmit)}>
        <div className="flex flex-col justify-between items-center gap-3 sm:flex-row min-w-72 sm:min-w-80 lg:min-w-96">
          <InputField
            name="name"
            label="Name"
            type="text"
            autoComplete="off"
            register={register}
            errors={errors.name}
          />
        </div>
        <SelectField
          name="account_type_id"
          label="Account Type"
          register={register}
          data={[{ id: "", name: "-- Select Type" }, ...accountTypes]}
          errors={errors.account_type_id}
        />
        <SelectField
          name="category_id"
          label="Category"
          register={register}
          data={[{ id: "", name: "-- Select Category" }, ...categories]}
          errors={errors.category_id}
        />
        <SelectField
          name="currency_id"
          label="Currency"
          register={register}
          data={[{ id: "", name: "-- Select Currency" }, ...currencies]}
          errors={errors.currency_id}
        />
        <ResourseButtons loading={edit ? editAccountLoad : addAccountLoad} />
      </form>
    </div>
  );
};

export default AddChartAccount;
